import { createSlice } from "@reduxjs/toolkit"

export const activeVouchersListSlice = createSlice({
	name: "activevouchers_list",
	initialState: {
		vouchers: "",
		errors: [],
	},

	reducers: {
        getActiveVouchers: (state, action) => {
           
			state.vouchers = action.payload
		},
		getActiveVouchersList: (state, action) => {
            
			state.vouchers = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getActiveVouchers, getActiveVouchersList, getErrors} = activeVouchersListSlice.actions

export default activeVouchersListSlice.reducer
